exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wl-container[data-v-71351ad3] {\n  height: 100%;\n}\n.table-operator[data-v-71351ad3] {\n  height: calc(100% - 0.25rem);\n}\n.wl-table[data-v-71351ad3] {\n  margin-bottom: 0.03125rem;\n}\n.wl-btn-container[data-v-71351ad3] {\n  height: 0.25rem;\n  padding: 0;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}", ""]);

// exports
